import {injectReducer} from '../../store/reducers'
import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'chatbot-interests', // TODO: Check this change
  onEnter: isLoggedIn(store),
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
     and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      // const HomeView = require('./components/HomeView').default;
      const CustomerInterest = require('./containers/ChatbotInterestsContainer').default;
      const {chatbotInterestsFilterReducer, chatbotInterestsReducer, loadStoreOptionsReducer} = require('./modules/chatbotInterests');

      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, {key: 'chatbotInterestsFilter', reducer: chatbotInterestsFilterReducer});
      injectReducer(store, {key: 'chatbotInterests', reducer: chatbotInterestsReducer});
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer})

      /*  Return getComponent   */
      cb(null, CustomerInterest)

      /* Webpack named bundle   */
    }, 'HomeView')
  }
})



// WEBPACK FOOTER //
// ./src/routes/ChatbotInterests/index.js